import vk from "./../../img/icons/vk.svg";
import inst from "./../../img/icons/instagram.svg";
import tw from "./../../img/icons/twitter.svg";
import git from "./../../img/icons/gitHub.svg";
import linkedIn from "./../../img/icons/linkedIn.svg";

import "./style.css";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer__wrapper">
            <ul className="social">
              <li className="social__item">
                <a href="https://vk.com/id438194181">
                  <img src={vk} alt="Link" />
                </a>
              </li>
              <li className="social__item">
                <a href="#!">
                  <img src={inst} alt="Link" />
                </a>
              </li>
              <li className="social__item">
                <a href="#!">
                  <img src={tw} alt="Link" />
                </a>
              </li>
              <li className="social__item">
                <a href="https://niknovgorod.github.io/portfolio/">
                  <img src={git} alt="Link" />
                </a>
              </li>
              <li className="social__item">
                <a href="#!">
                  <img src={linkedIn} alt="Link" />
                </a>
              </li>
            </ul>
            <div className="copyright">
              <p>© 2026 frontend</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
